module.exports = __webpack_public_path__ + "img/filterx.cbe44805.svg";